<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Add Exam Plan </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        @change="getData();getStd();"
                        persistent-hint
                        hint="Please select academic year"
                    />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list" item-text="sem" item-value="id" label="Semester" persistent-hint hint="Please select semester" />
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" multiple :items="std_div_list" item-text="std" item-value="std_id" label="Standard" outlined persistent-hint hint="Please select standard" />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        dense
                        required
                        outlined
                        rounded
                        color="#0F2027"
                        v-model="assessment_detail"
                        :items="assessment_detail_list"
                        item-text="assessmenttype"
                        item-value="id"
                        label="Assessment Type"
                        persistent-hint
                        hint="Please select Assessment Type"
                        @click="show = false"
                    />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field dense outlined rounded v-model="new_from_date" @blur="date1 = parseDate(new_from_date)" v-on="on" prepend-icon="event" persistent-hint label="From Date"></v-text-field>
                        </template>
                        <v-date-picker v-model="date1" no-title @input="menu1 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field dense outlined rounded v-model="new_to_date" @blur="date2 = parseDate(new_to_date)" v-on="on" prepend-icon="event" persistent-hint label="To Date"></v-text-field>
                        </template>
                        <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-text-field label="Exam Name" rounded outlined dense v-model="exam_name"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-text-field type="number" label="Max Slots In Day" rounded outlined dense v-model="timeSlotCount" @change="generateTimeSlots()"></v-text-field>
                </v-col>
                <v-row dense justify="center" v-if="timeSlots.length">
                    <v-col v-for="(slot, index) in timeSlots" :key="index" cols="12" md="3" sm="3">
                        <p><v-icon color="error">*</v-icon><b>Time Slot {{ index + 1 }}</b></p>
                        <!-- From Time Picker -->
                        <v-menu v-model="slot.menuFrom" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field rounded outlined dense v-model="slot.fromTime" label="From Time" prepend-icon="mdi-clock" readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-card>
                                <v-time-picker v-model="slot.fromTime" @change="onTimeChange(index, 'fromTime', slot.fromTime)"></v-time-picker>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn text @click="slot.menuFrom = false">Cancel</v-btn>
                                    <v-btn text @click="slot.menuFrom = false">OK</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-menu>

                        <!-- End Time Picker -->
                        <v-menu v-model="slot.menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field rounded outlined dense v-model="slot.endTime" label="End Time" prepend-icon="mdi-clock" readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-card>
                                <v-time-picker v-model="slot.endTime" @change="onTimeChange(index, 'endTime', slot.endTime)"></v-time-picker>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn text @click="slot.menuEnd = false">Cancel</v-btn>
                                    <v-btn text @click="slot.menuEnd = false">OK</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="3" sm="3" v-if="timeSlots.length">
                        <p><b>Selected Time Slots:</b></p>
                        <ul>
                            <li v-for="(slot, index) in timeSlots" :key="index">
                                Slot {{ index + 1 }}: From {{ slot.fromTime }} to {{ slot.endTime }}
                            </li>
                        </ul>
                    </v-col>
                </v-row>
                <!-- <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-menu v-model="menu3" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field rounded outlined dense v-model="formattedTime" label="Select From Time" prepend-icon="mdi-clock" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-card>
                            <v-time-picker v-model="time" @change="onTimeChange"></v-time-picker>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text @click="menu3 = false">Cancel</v-btn>
                                <v-btn text @click="menu3 = false">OK</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-menu v-model="menu4" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field rounded outlined dense v-model="formattedTo_ime" label="Select To Time" prepend-icon="mdi-clock" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-card>
                            <v-time-picker v-model="to_time" @change="onTimeChangeToTime"></v-time-picker>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text @click="menu4 = false">Cancel</v-btn>
                                <v-btn text @click="menu4 = false">OK</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>
                </v-col> -->

                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sel_std_data  && assessment_detail && new_from_date && new_to_date && exam_name && timeSlotCount">
                    <v-btn class="mt-6 button" @click="saveplandetails()" :loading="fetch_loader">Save Plan Details</v-btn>
                </v-col>
            </v-row>

            <v-row v-if="exam_plan_list!=''" justify="center" dense class="no-display">
                <v-col cols="12" sm="12" md="12">
                    <v-toolbar class="toolbar no-display" flat dense>
                        <v-toolbar-title>
                            <strong> Exam Plan </strong>
                        </v-toolbar-title>
                    </v-toolbar> <br>
                    <v-data-table :headers="headers" :items="exam_plan_list" class="elevation-1 mytable" dense v-if="exam_plan_list != ''">
                        <template v-slot:item.isApproved="{ item }">
                            <v-switch v-model="item.isApproved" @change="savePlanStatus(item,'is_approved',item.isApproved)"></v-switch>
                            <!-- <span v-if="item.isApproved">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span> -->
                        </template>
                        <template v-slot:item.isCurrent="{ item }">
                            <v-switch v-model="item.isCurrent" @change="savePlanStatus(item,'iscurrent',item.isCurrent)"></v-switch>
                            <!-- <span v-if="item.isCurrent">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span> -->
                        </template>
                        <template v-slot:item.add_crs_schedule="{ item }">
                            <v-btn rounded small class="mb-2 button" @click="addSchedule(item)">Add Course Schedule</v-btn>
                        </template>
                        <template v-slot:item.delete="{ item }">
                            <v-btn :disabled="item.delete == false" icon @click="deleteSchedule(item)">
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon small color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card>

        <v-dialog v-model="dialog_add" max-width="1900px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>Add Subject Schedule</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row v-if="exam_plan_data!=null" dense justify="center">
                            <!-- {{ exam_plan_data.exam_detailed_schedule_list }} -->
                            <v-col cols="12" sm="3" md="3">
                                <v-autocomplete
                                    color="#0F2027"
                                    dense
                                    rounded
                                    required
                                    v-model="exam_crs_std"
                                    item-value="id"
                                    :items="exam_plan_data.std_list"
                                    item-text="std"
                                    label="Select Standard"
                                    outlined
                                    persistent-hint
                                    @change="getStdCourse(exam_crs_std)"
                                    hint="Please Select Standard"
                                />
                            </v-col>
                            <v-col cols="12" sm="3" md="3" v-if="crs_list != ''">
                                <v-autocomplete color="#0F2027" dense rounded required v-model="crs_id" item-value="c_id" :items="crs_list" item-text="course" label="Course" outlined persistent-hint hint="Please select course" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-autocomplete
                                    color="#0F2027"
                                    dense
                                    rounded
                                    required
                                    v-model="exam_crs_slot"
                                    item-value="eds_id"
                                    :items="exam_plan_data.exam_detailed_schedule_list"
                                    item-text="slot"
                                    label="Select Slot"
                                    outlined
                                    persistent-hint
                                    hint="Please Select slot"
                                />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-btn class="button" :disabled="exam_plan_data.isApproved" v-if="exam_crs_slot && crs_id && exam_crs_std" @click="saveCrsExamPlan(exam_crs_slot,exam_crs_std,crs_id)">Save</v-btn>
                            </v-col>
                        </v-row>
                        <v-col cols="12" sm="12" md="12" v-if="exam_crs_sechedule_list != ''">
                            <v-toolbar class="toolbar no-display" flat dense>
                                <v-toolbar-title>
                                    <strong> Coursewise Exam Plan Details </strong>
                                </v-toolbar-title>
                            </v-toolbar>
                            <br />
                            <v-data-table :headers="headers_crs" :items="bookList1" class="elevation-1 mytable" @current-items="getFiltered" dense v-if="exam_crs_sechedule_list != ''">
                                <template v-slot:top class="pb-5">
                                    <v-row justify="center">
                                        <v-col cols="12" sm="12" md="12">
                                            <tr class="t-row">
                                                <div>
                                                    <th>
                                                        <v-row>
                                                            <span v-for="header in headers_crs" :key="header.text">
                                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                                    <v-autocomplete
                                                                        class="mr-2 pb-5 pt-2"
                                                                        flat
                                                                        hide-details
                                                                        small
                                                                        rounded
                                                                        dense
                                                                        outlined
                                                                        color="#0F2027"
                                                                        :label="header.text"
                                                                        multiple
                                                                        clearable
                                                                        :items="columnValueList(header.value)"
                                                                        v-model="filters[header.value]"
                                                                    ></v-autocomplete>
                                                                </span>
                                                            </span>
                                                        </v-row>
                                                    </th>
                                                </div>
                                            </tr>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-card>
                    <v-row justify="center">
                        <v-btn class="button" @click="dialog_add = false">Cancel</v-btn>
                    </v-row>
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-model="delete_dailog" max-width="1000px">
          <v-card>
              <v-toolbar class="toolbar no-display" flat dense>
                  <v-toolbar-title>
                      <strong> Delete Exam Plan </strong>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn fab small color="white" outlined icon @click="delete_dailog = false"><v-icon> mdi-close </v-icon></v-btn>
              </v-toolbar>
              <center>
                  <strong>Are you sure you want delete this exam plan???</strong>
              </center>
              <v-row justify="center">
                  <v-btn class="button" text @click="delete_dailog = false">No</v-btn>
                  <v-btn class="button" text @click="deleteExamPlan(exam_plan_id)">Yes</v-btn>
              </v-row>
          </v-card>
      </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    import "jspdf-autotable";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                overlay: false,
                selected: [],
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                assessment_detail_list: [],
                assessment_detail: null,
                standard: null,
                division: null,
                course: null,
                ass_Scheme: null,
                academicyear: null,
                ass_detail_list: null,
                org_basic_data: [],
                date1: new Date().toISOString().substr(0, 10),
                date2: new Date().toISOString().substr(0, 10),
                menu1: false,
                menu2: false,
                new_from_date: null,
                new_to_date: null,
                menu3: false,
                menu4: false,
                exam_crs_slot: null,
                exam_crs_std: null,
                crs_id: null,
                // time: null, // Time value
                // to_time:null,
                // formattedTime: null, // Display formatted time
                // formattedTo_ime: null, // Display formatted time
                timeSlotCount: null, // User input for the number of time slots
                timeSlots: [], // Array to hold the dynamically created time pickers for each slot
                exam_name: null,
                exam_plan_list: [],
                dialog_add: false,
                exam_plan_data: null,
                exam_plan_id:null,
                crs_list: [],
                exam_crs_sechedule_list: [],
                filterArr: [],
                delete_dailog:false,
                filters: {
                    ecs_standard: [],
                    ecs_day: [],
                    ecs_exam_date: [],
                    ecs_from_time: [],
                    ecs_to_time: [],
                },
                headers_crs: [
                    { text: "Sr. No.", value: "sr_no" },
                    { text: "Exam Name", value: "ecs_examplan" },
                    { text: "Standard", value: "ecs_standard" },
                    { text: "Course", value: "ecs_course" },
                    { text: "Exam Date", value: "ecs_exam_date" },
                    { text: "Day", value: "ecs_day" },
                    { text: "From Time", value: "ecs_from_time" },
                    { text: "To Time", value: "ecs_to_time" },
                ],
                headers: [
                    { text: "Sr. No.", value: "sr_no" },
                    { text: "Exam Name", value: "exam_name" },
                    { text: "Plan Name", value: "plan_name" },
                    { text: "Start Date", value: "start_date" },
                    { text: "End Date", value: "end_date" },
                    { text: "Standard", value: "ep_std_name" },
                    { text: "Max. Number Of Slots In Day", value: "maximum_number_of_slots_in_day" },
                    { text: "Academic Year", value: "academicyear" },
                    { text: "Semester", value: "semester" },
                    { text: "Assessmenttype", value: "assessmenttype" },
                    { text: "Is Approved ?", value: "isApproved" },
                    { text: "Is Current ?", value: "isCurrent" },
                    { text: "Add Course Schedule", value: "add_crs_schedule" },
                    { text: "Delete", value: "delete" },
                ],
            };
        },
        computed: {
            bookList1() {
                return this.exam_crs_sechedule_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        watch: {
            date1(val) {
                this.new_from_date = this.formatDate(this.date1);
            },
            date2(val) {
                this.new_to_date = this.formatDate(this.date2);
            },
        },

        methods: {
            // onTimeChange(val) {
            //     this.formattedTime = val; // Format time as needed
            // },
            // onTimeChangeToTime(val) {
            //     this.formattedTo_ime = val; // Format time as needed
            // },
            // Method to generate time slots based on user input
            generateTimeSlots() {
                this.timeSlots = [];
                for (let i = 0; i < this.timeSlotCount; i++) {
                    this.timeSlots.push({
                        fromTime: "", // To store the "From Time"
                        endTime: "", // To store the "End Time"
                        menuFrom: false, // Control menu for "From Time" picker
                        menuEnd: false, // Control menu for "End Time" picker
                    });
                }
            },
            // Method to handle the time change for each slot
            onTimeChange(index, type, newTime) {
                this.timeSlots[index][type] = newTime;
            },
            addSchedule(item) {
                this.exam_plan_data = item;
                this.dialog_add = true;
                this.getCrsExamPlan();
            },
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.exam_crs_sechedule_list.map((d) => d[val]);
            },
            deleteSchedule(item){
                this.exam_plan_id = item.plan_id
                this.delete_dailog = true
            },
            async deleteExamPlan(exam_plan_id){
                const data={
                    exam_plan_id:exam_plan_id
                }
                try {
                    const res = await axios.post("/Examination/deleteExamPlan", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Deleted successfully");
                        this.getData();
                        this.delete_dailog = false
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    this.onerror(err);
                } finally {
                }
            },
            async savePlanStatus(item,type,status){
                const data = {
                    exam_plan: item.plan_id,
                    type:type,
                    status:status
                };
                try {
                    const res = await axios.post("/Examination/savePlanStatus", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.getData();
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    this.onerror(err);
                } finally {
                }
            },
            async getCrsExamPlan() {
                this.exam_crs_echedule_list = [];
                const data = {
                    exam_plan: this.exam_plan_data.plan_id,
                };
                try {
                    const res = await axios.post("/Examination/getCrsExamPlan", data);
                    if (res.data.flag == "YES") {
                        this.exam_crs_sechedule_list = res.data.exam_crs_sechedule_list;
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    this.onerror(err);
                } finally {
                }
            },
            async saveCrsExamPlan(exam_crs_slot, exam_crs_std, crs_id) {
                const data = {
                    standard: exam_crs_std,
                    slot: exam_crs_slot,
                    crs_id: crs_id,
                };
                try {
                    const res = await axios.post("/Examination/saveCrsExamPlan", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.getCrsExamPlan();
                    } 
                    else if (res.data.flag == "NO") {
                        this.showSnackbar("#4caf50", res.data.fmsg);
                        this.getCrsExamPlan();
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    this.onerror(err);
                } finally {
                }
            },
            getStdCourse(exam_crs_std) {
                this.crs_list = [];
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: exam_crs_std,
                };
                axios
                    .post("/Examination/getStandardCourse", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.crs_list = res.data.courses_list;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", "No courses offered for this standard..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            async getData() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                };
                try {
                    const res = await axios.post("/Examination/getExamPlanDetails", data);
                    if (res.data.flag == "YES") {
                        this.exam_plan_list = res.data.exam_plan_list;
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    this.onerror(err);
                } finally {
                }
            },
            async saveplandetails() {
                for (var i = 0; i < this.timeSlots.length; i++) {
                    if (this.timeSlots[i].fromTime == "" || this.timeSlots[i].fromTime == null) {
                        this.showSnackbar("#b71c1c", "Please enter from time of slot number " + (i + 1));
                        return;
                    } else if (this.timeSlots[i].endTime == "" || this.timeSlots[i].endTime == null) {
                        this.showSnackbar("#b71c1c", "Please enter end time of slot number " + (i + 1));
                        return;
                    }
                }
                const data = {
                    timeSlots: this.timeSlots,
                    ay: this.sel_ay_data.ay_id,
                    std: this.sel_std_data,
                    ass_type: this.assessment_detail,
                    from_date: this.new_from_date,
                    to_date: this.new_to_date,
                    exam_name: this.exam_name,
                    timeSlotCount: this.timeSlotCount,
                    sem: this.sem,
                };
                this.fetch_loader = true;
                try {
                    const res = await axios.post("/Examination/saveExamPlanDetails", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.getData();
                        this.fetch_loader = false;
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    this.onerror(err);
                    this.fetch_loader = false;
                } finally {
                    this.fetch_loader = false;
                    (this.timeSlots = []),
                        (this.sel_ay_data = null),
                        (this.sel_std_data = null),
                        (this.assessment_detail = null),
                        (this.new_from_date = null),
                        (this.new_to_date = null),
                        (this.exam_name = null),
                        (this.timeSlotCount = null),
                        (this.sem = null);
                }
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            putnull3() {
                this.show = false;
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please Select Proper Data.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.semester_list = res.data.semester_list_wws;
                        this.sem = this.semester_list;
                        this.assessment_detail_list = res.data.assessment_detail_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
</style>
